export default __webpack_public_path__ + "static/media/step-1-en.81a09e35.svg";